// CoreAPI's own display symbols for unit ids; other ids are shown as they are, like CoreAPI does
const UNIT_SYMBOLS: Record<string, string> = {
    m2: "m²",
    m3: "m³",
};

/** A bundle's quantity split for display, e.g. "12,5" and "m²". Null when CoreAPI sent no quantity. */
export interface BundleQuantityParts {
    value: string;
    unit: string | null;
}

/**
 * translatePieces gives the localized "pcs" abbreviation (kpl in Finnish), the only unit CoreAPI translates.
 */
export const getBundleQuantityParts = (amount: number | null,
                                       unitId: string | null,
                                       language: string,
                                       translatePieces: () => string): BundleQuantityParts | null => {
    if (amount === null) return null;

    const value = amount.toLocaleString(language, { maximumFractionDigits: 2 });
    if (!unitId) return { value, unit: null };

    return { value, unit: unitId === "pcs" ? translatePieces() : UNIT_SYMBOLS[unitId] ?? unitId };
};

/** A bundle's quantity for display, e.g. "12,5 m²". Null when CoreAPI sent no quantity. */
export const formatBundleQuantity = (amount: number | null,
                                     unitId: string | null,
                                     language: string,
                                     translatePieces: () => string): string | null => {
    const parts = getBundleQuantityParts(amount, unitId, language, translatePieces);
    if (!parts) return null;
    return parts.unit ? `${parts.value} ${parts.unit}` : parts.value;
};
